import {Component, Input, OnInit} from '@angular/core';
import {SettingsStoreService} from "../_services/settings-store.service";
import {ApiRestService} from "../_services/api-rest.service";
import {Subscription} from "rxjs";
import {Setting} from "../_models/setting";
import {ActivatedRoute, Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {TranslateObj} from "../../shared/models/translatedesc";

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html'
})
export class SettingsComponent implements OnInit {
  subscriptions: Subscription = new Subscription();
  Settings: Setting[] = [];
  Setting_id: string;
  SettingLabel: string = undefined;
  @Input() HasAdd: boolean = true;
  stored: Setting;
  transaltedobjects: TranslateObj[];
  constructor(
    private settingsStore: SettingsStoreService,
    private apiRestService: ApiRestService,
    private route: ActivatedRoute,
    public router: Router,
    private toast: ToastrService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(data => {
      this.Setting_id= data['type'];
      if(this.Setting_id)
        this.refreshTable();
    })
  }
  add(){
    if(!this.SettingLabel)
      this.toast.warning("inserire almeno un valore","Attenzione")
    else
    this.apiRestService.AddSettings({id:undefined, label: this.SettingLabel, type: this.Setting_id}).subscribe(data=>{
      this.refreshTable();
      this.SettingLabel = undefined;
    })
  }
  edit(item: Setting){
    if(item.isInModify) {
      if(!item.label)
        this.toast.warning("inserire almeno un valore","Attenzione")
      else {
        this.apiRestService.UpdateSettings(item).subscribe(data=>{
          this.refreshTable();
        })
      }
    }
    item.isInModify = !item.isInModify;
  }
  delete(value){
    if(value.isInModify)
      this.refreshTable();
    else if(confirm("Sei sicuro di voler cancellare questo elemento?"))
      this.apiRestService.DeleteSettings(value).subscribe(data=>{
        this.refreshTable();
      });
  }
  refreshTable(){
    this.apiRestService.GetSetting({id: this.Setting_id, label: "", type: this.Setting_id}).subscribe(data=>{
      this.Settings = data;
    })
  }

  openModal(targetModal: NgbModal, Selected: Setting) {
    this.apiRestService.GetSettingLingue(Selected).subscribe(data=> {
      this.modalService.open(targetModal, { centered: true, backdrop: 'static'});
      this.stored = Selected;
      this.stored.traduzioni = data;
      this.transaltedobjects = Selected.traduzioni?.length > 0 ? this.gettransaltedobjects(this.stored): this.createlang(this.stored,["en", "es", "fr", "de"]);
    });

  }

  createlang(item: Setting,values: string[]): TranslateObj [] {
    var output: TranslateObj [] = [];
    output.push({
      default: true,
      lang: "it",
      TranslateInputs: [ {id: "label", label:"Label", value:item?.label ? item.label : "", type: "text"},]
    })
    values?.forEach(value=>{
      output.push({
        default: false,
        lang: value,
        TranslateInputs: [
          {id: "label", label:"Label", value: "", type: "text"},
        ]
      })
    })
    return output;
  }

  gettransaltedobjects(item: Setting): TranslateObj[]{
    return [{
      default: true,
      lang: "it",
      TranslateInputs: [ {id: "label", label:"Label", value: item?.label, type: "text"},]
    }
    ].concat(item.traduzioni);
  }
  saveModalButton() {
    if (this.stored) {
      const updateData = this.stored;
      updateData.label = this.transaltedobjects?.find(x => x.default)?.TranslateInputs?.find(x => x.id == "label")?.value;
      updateData.traduzioni = this.transaltedobjects?.filter(x => !x.default)
      this.apiRestService.UpdateSettings(updateData).subscribe(data=>{
        this.refreshTable();
        this.closeBtnClick();
      })
    }
  }
  closeBtnClick() {
    this.modalService.dismissAll();
  }
}
